import React, {Component} from 'react';
import AFRAME from 'aframe';
import {Entity, Scene} from 'aframe-react';
import * as THREE from 'three';
import bowser from 'bowser';
import io from 'socket.io-client';
//import queryString from 'query-string';

import './App.css';

import macData from './macs.yml';

import './components/look-at';
import './components/my-wasd-controls';
import './components/alphamap';

import LoginForm from './LoginForm';

const LAST_ORBIT_RADIUS = 20;
const SCENE_RADIUS = 22;
const USER_HEIGHT = 1.6;
const MAC_HEIGHT = 1.5;
const MAC_RADIUS = 1.5;

class App extends Component {

    constructor() {
        super();

        this.xApiState = this.xApiState.bind(this);
        this.macClick = this.macClick.bind(this);
        this.cursorMouseenter = this.cursorMouseenter.bind(this);
        this.cursorMouseleave = this.cursorMouseleave.bind(this);
        this.macPowerOn = this.macPowerOn.bind(this);
        this.macPowerOff = this.macPowerOff.bind(this);
        this.enterVR = this.enterVR.bind(this);
        this.exitVR = this.exitVR.bind(this);
        this.onVideoEnded = this.onVideoEnded.bind(this);
        this.onSceneLoaded = this.onSceneLoaded.bind(this);
        this.handleLoginFormClose = this.handleLoginFormClose.bind(this);
        this.handleLoginFormSubmit = this.handleLoginFormSubmit.bind(this);

        let app = this;

        let showForm = window.location.search.indexOf('fira') !== -1;
        this.music = window.location.search.indexOf('nomusic') === -1; //&& !AFRAME.utils.device.isMobile();

        this.state = {
            form: showForm,
            playing: false,
            currentMac: null,
            vr: false,
            oculus: false,
            cardboard: false
        };

        this.socket = new io(window.location.protocol + '//' + window.location.host + '/', {
            path: '/mac/socket.io',
        });

        if (showForm) {
            this.userData = JSON.parse(localStorage.getItem('userData'));
        } else {
            this.socket.emit('logged-in', {});
        }

        this.socket.emit('initialized');

        this.hovering = null;

        this.clickCooldown = false;

        this.macFamilies = [];
        this.macTextures = [];
        this.macDescs = [];
        this.macNames = [];
        this.macSounds = [];

        let loadedSounds = [];
        macData.forEach(mac => {
            // Family
            let family = this.macFamilies.find(f => f.name === mac.family);
            if (!family) {
                family = {
                    name: mac.family,
                    macs: []
                };
                this.macFamilies.push(family);
            }
            let box = mac.box.split(' ').map(e => e / 100); // top bottom left right as %
            mac.offset = box[2].toFixed(4) + ' ' + box[1].toFixed(4);
            mac.height = (1 - box[0] - box[1]).toFixed(4);
            mac.width = (1 - box[2] - box[3]).toFixed(4);
            mac.repeat = mac.width + ' ' + mac.height;
            family.macs.push(mac);

            this.macTextures.push(<img key={`${mac.id}-off`} id={`${mac.id}-off`} src={`assets/off/${mac.id}.png`} alt={mac.name}></img>);
            //this.macTextures.push(<img key={`${mac.id}-on`} id={`${mac.id}-on`} src={`assets/on/${mac.id}.png`} alt={mac.name}></img>);
            this.macTextures.push(<img key={`${mac.id}-alpha`} id={`${mac.id}-alpha`} src={`assets/alpha/${mac.id}.jpg`} alt={mac.name}></img>);
            this.macTextures.push(<video preload="none" poster={`${mac.id}-off`} playsInline key={`${mac.id}-video`} id={`${mac.id}-video`} src={`assets/video/${mac.id}.mp4`} alt={mac.name} width="1024" height="1024" onEnded={this.onVideoEnded}></video>);
            this.macTextures.push(<img key={`${mac.id}-title`} id={`${mac.id}-title`} src={`assets/title/${mac.id}.png`} alt={mac.name}></img>);
            this.macTextures.push(<img key={`${mac.id}-desc`} id={`${mac.id}-desc`} src={`assets/description/${mac.id}.png`} alt={mac.name}></img>);
            if (loadedSounds.indexOf(mac.sound) === -1) {
                loadedSounds.push(mac.sound);
                this.macSounds.push(<audio key={`${mac.sound}-sound`} id={`${mac.sound}-sound`} src={`assets/audio/${mac.sound}.mp3`}></audio>)
            }
        });
        this.macDescs.push(<img key={`mac-desc`} id={`mac-desc`} src={`assets/Letras.png`} alt={`Desc`}></img>);

        AFRAME.registerComponent('mac-scene', {
            init: function() {
                let sceneEl = document.querySelector('a-scene');
                app.player = this.player = sceneEl.querySelector('#player');
                app.camera = this.camera = sceneEl.querySelector('#camera');
                this.lastPosition = app.toFixed(app.player.getAttribute('position'));
                this.lastRotation = app.toFixed(app.camera.getAttribute('rotation'));
                this.tick = AFRAME.utils.throttleTick(this.tick, 250, this);
            },
            tick: function (t, dt) {
                let newPosition = app.toFixed(app.player.getAttribute('position'));
                let newRotation = app.toFixed(app.camera.getAttribute('rotation'));
                if (!AFRAME.utils.deepEqual(this.lastPosition, newPosition) || !AFRAME.utils.deepEqual(this.lastRotation, newRotation)) {
                    app.socket.emit('interacted', app.xApiState());
                    this.lastPosition = newPosition;
                    this.lastRotation = newRotation;
                }
            }
        });

        AFRAME.registerComponent('mycontrols', {
            init: function () {
                var el = this.el;
                var pointing = false;
                var lastEls = [];
                var ray = this.el.querySelector('[raycaster]');

                function click(e) {
                    e.emit('click', {hand: el});
                }

                el.addEventListener('abuttondown', function (evt) {
                    ray.components.raycaster.intersectedEls.forEach(e => {
                        click(e);
                    });
                });

                el.addEventListener('pointingstart', function (e) {
                    pointing = true;
                    // Emit click on all the intersected elements
                    ray.components.raycaster.intersectedEls.forEach(e => {
                        click(e);
                    });
                });

                el.addEventListener('pointingend', function (e) {
                    pointing = false;
                });

                ray.addEventListener('raycaster-intersection', function (e) {
                    // Check if there are changes in the intersected elements
                    if (e.detail.els.length !== lastEls.length || !e.detail.els.every(e => lastEls.indexOf(e.id) !== -1)) {
                        if (pointing) {
                            // Emit click on the new ones
                            e.detail.els.forEach(e => {
                                if (lastEls.indexOf(e.id) === -1) {
                                    click(e);
                                }
                            });
                        }
                        lastEls = e.detail.els.map(e => e.id);
                    }
                });

                ray.addEventListener('raycaster-intersection-cleared', function (e) {
                    lastEls = [];
                });

            }
        });

        AFRAME.registerComponent('insideradius', {
            schema: {
                radius: {default: 15, type: 'int'},
                origin: {default: {x: 0, y: 0, z: 0}, type: 'vec3'}
            },
            init: function () {
                this.lastTime = 0;
                this.radius = this.data.radius;
                this.origin = new THREE.Vector3(this.data.origin.x, this.data.origin.y, this.data.origin.z);
            },
            tick: function (time, timeDelta) {
                let currentPosition = this.el.object3D.position;
                let distance = currentPosition.distanceTo(this.origin);
                if (distance > this.radius) {
                    let fromCircleToObject = currentPosition.clone().sub(this.origin);
                    fromCircleToObject.multiplyScalar(this.radius / fromCircleToObject.length());
                    let position = this.origin.clone().add(fromCircleToObject);
                    position.y = this.el.getAttribute('position').y;
                    this.el.object3D.position.set(position.x, position.y, position.z);
                }
                if (time - this.lastTime > 1000) {
                    this.lastTime = time;
                }
            }
        });

        AFRAME.registerComponent('joystick', {
            init: function () {
                var el = this.el;
                let leftHand = document.querySelector('#leftHand');
                let rightHand = document.querySelector('#rightHand');
                this.forward = new THREE.Vector3(0, 0, -1);
                this.right = new THREE.Vector3(1, 0, 0);
                this.controllerPos = new THREE.Vector2(0, 0);
                this.controllerOrigin = new THREE.Vector2(0, 0);

                let movement = (evt) => {
                    var matrix = new THREE.Matrix4();
                    matrix.extractRotation(evt.target.object3D.matrix);
                    var vector = new THREE.Vector3(0, 0, -1);
                    vector.applyMatrix4(matrix);
                    vector.projectOnPlane(evt.target.object3D.up);
                    var angle = vector.angleTo(this.forward);
                    var sign = Math.sign(vector.dot(this.right));
                    angle = sign * angle;
                    this.controllerPos.x = evt.detail.axis[0];
                    this.controllerPos.y = evt.detail.axis[1];
                    this.controllerPos.rotateAround(this.controllerOrigin, angle);
                };

                leftHand.addEventListener('axismove', movement);
                rightHand.addEventListener('axismove', movement);

                this.lastTime = 0;
            },
            tick: function (time, timeDelta) {
                let seconds = timeDelta / 1000;
                let position = this.el.getAttribute('position');
                position.x += this.controllerPos.x * seconds;
                position.z += this.controllerPos.y * seconds;
                this.el.object3D.position.x = position.x;
                this.el.object3D.position.z = position.z;
                if (time - this.lastTime > 1000) {
                    this.lastTime = time;
                }
            }
        });
    }

    handleLoginFormClose() {
        this.setState({
            form: false
        });

        this.socket.emit('logged-in', {
            userData: {}
        });
    }

    handleLoginFormSubmit(data) {
        localStorage.setItem('userData', JSON.stringify(data));

        this.userData = data;
        this.setState({
            form: false
        });

        this.socket.emit('logged-in', data);
    }

    toFixed(data) {
        return {
            x: +(data.x).toFixed(2),
            y: +(data.y).toFixed(2),
            z: +(data.z).toFixed(2)
        };
    }

    xApiState() {
        let rotation = this.toFixed(this.camera.getAttribute('rotation'));
        console.log('Lat: ', rotation.x, 'lon: ', rotation.y)
        return {
            vrDevice: {
                vrMode: this.state.vr,
                positionalTracking: !!AFRAME.utils.device.checkHasPositionalTracking(),
                headset: !!AFRAME.utils.device.checkHeadsetConnected(),
                mobile: !!AFRAME.utils.device.isMobile()
            },
            position: this.toFixed(this.player.getAttribute('position')),
            latitude: rotation.x,
            longitude: -rotation.y,
            timestamp: new Date()
        }
    }

    macClick(e) {
        if (!this.clickCooldown) {
            this.clickCooldown = true;
            setTimeout(() => {
                this.clickCooldown = false;
            }, 2000);
            let el = e.target;
            let id = el.dataset.id;
            let hand = e.detail.hand ? e.detail.hand.id : null;
            let parent = el.parentElement;

            if (hand === null) { // No hand-interaction
                let player = document.querySelector('#player');

                let p0 = player.getAttribute('position');
                let p1 = parent.getAttribute('position');

                let angle = Math.atan2(p1.z - p0.z, p1.x - p0.x);

                let p2 = {
                    x: p1.x - (Math.cos(angle) * MAC_RADIUS),
                    y: p0.y,
                    z: p1.z - (Math.sin(angle) * MAC_RADIUS)
                };

                new AFRAME.TWEEN.Tween(p0)
                    .to(p2)
                    .easing(AFRAME.TWEEN.Easing.Quadratic.Out)
                    .onUpdate(() => {
                        player.setAttribute('position', p0);
                    })
                    .start();

                //player.setAttribute('position', p2);

            }

            if (this.state.currentMac !== null) {
                let old = document.querySelector('#' + this.state.currentMac);
                let video = document.querySelector('#' + this.state.currentMac + '-video');
                this.socket.emit('paused', Object.assign(this.xApiState(), {
                    video: video.src,
                    trigger: hand !== null ? hand : (this.state.cardboard ? 'fuse' : 'click'),
                    time: video.currentTime,
                    volume: video.muted ? 0 : 1
                }));
                old.emit('power-off');
            }

            if (this.state.currentMac !== id) {
                this.setState({
                    playing: false,
                    currentMac: id,
                    currentHand: hand
                }, () => {
                    parent.emit('power-on');
                    this.socket.emit('played', Object.assign(this.xApiState(), {
                        video: document.querySelector('#' + el.dataset.id + '-video').src,
                        trigger: hand !== null ? hand : (this.state.cardboard ? 'fuse' : 'click'),
                        time: document.querySelector(el.getAttribute('src')).currentTime,
                        volume: document.querySelector(el.getAttribute('src')).muted ? 0 : 1
                    }));
                });
            } else {
                this.setState({
                    playing: true,
                    currentMac: null,
                    currentHand: null
                })
            }
        }
    }

    cursorMouseenter(event) {
        if (event.detail.els[0].classList.contains('clickable') && event.detail.els[0] !== this.hovering) {
            this.hovering = event.detail.els[0];
            event.target.emit('focusin');
        }
    }

    cursorMouseleave(event) {
        this.hovering = null;
        //if (event.detail.intersection.distance < 0.5 && event.detail.intersectedEl.classList.contains('clickable')) {
        event.target.emit('focusout');
        //}
    }

    macPowerOn(event) {
        document.querySelector('#' + event.target.dataset.id + '-video').play();
        if (this.audioLoop)
            this.audioLoop.volume = 0.25;
    }

    macPowerOff(event) {
        let video = document.querySelector('#' + event.target.dataset.id + '-video');
        video.pause();
        video.currentTime = 0;
        if (this.audioLoop)
            this.audioLoop.volume = 0.5;
    }

    enterVR() {
        let cardboard = AFRAME.utils.device.isMobile();
        if (cardboard) {
            // Fix Aframe 0.7.1 bug that adds offsetHeight when VR mode with no headset
            /*setTimeout(() => {
                document.querySelector('#camera').setAttribute('position', 'y', USER_HEIGHT);
            }, 100);*/
            if (bowser.chrome && (bowser.mobile || bowser.tablet)) {
                // Fix Chrome bug that does not play not muted videos on android
                //[...document.querySelectorAll('video')].forEach(e => e.setAttribute('muted', true));
                [...document.querySelectorAll('video')].forEach(e => e.muted = true);
            }
        }
        if (this.camera && this.player) {
            // enterVR gets called on a window refresh BEFORE the scene is built. Only do this after that.
            this.setState({
                vr: true,
                oculus: (!AFRAME.utils.device.isMobile() && AFRAME.utils.device.checkHeadsetConnected()),
                cardboard: cardboard
            }, () => {
                this.socket.emit('interacted', this.xApiState());
            });
        }
    }

    exitVR() {
        //[...document.querySelectorAll('video')].forEach(e => e.setAttribute('muted', false));
        [...document.querySelectorAll('video')].forEach(e => e.muted = false);
        this.setState({
            vr: false,
            oculus: false,
            cardboard: false
        }, () => {
            this.socket.emit('interacted', this.xApiState());
        });
    }

    onVideoEnded(e) {
        this.socket.emit('completed', Object.assign(this.xApiState(), {
            video: e.target.src,
            time: e.target.currentTime,
            volume: e.target.muted ? 0 : 1
        }));
        if (this.audioLoop)
            this.audioLoop.volume = 0.5;
    }

    onSceneLoaded() {
        this.audioLoop = document.querySelector('#loop');
        if (this.audioLoop) {
            this.audioLoop.volume = 0.5;
            this.audioLoop.play();
        }
    }

    render() {

        let currentMacDesc = null;

        let families = [];
        const F = this.macFamilies.length;
        const GAP = LAST_ORBIT_RADIUS / F;      // gap between each family
        this.macFamilies.forEach((family, idx) => {
            let macs = [];
            let N = family.macs.length;
            const R = GAP * (idx + 1);          // radius of this orbit
            const ARC = 360 / N;                // gap between elements
            const OFFSET = 10 * idx;            // incrementing offset
            family.macs.forEach((mac, i) => {
                let angle = (i * ARC + OFFSET) * Math.PI / 180;
                let position = {
                    x: Math.sin(angle) * R,
                    y: MAC_HEIGHT,
                    z: -Math.cos(angle) * R
                };

                if (this.state.currentMac === mac.id) {
                    currentMacDesc = <Entity className="macTextTexture clickable"
                                             data-id={mac.id}
                                             primitive="a-image" src={`#${mac.id}-desc`}
                                             events={{click: this.macClick}}
                                             transparent material="alphaTest: 0.5"></Entity>;
                }

                macs.push(<Entity key={i} id={mac.id} data-id={mac.id} className="mac" position={position}
                                  look-at="#camera" sound={`src: #${mac.sound}-sound; on: power-on`}
                                  events={{'power-on': this.macPowerOn, 'power-off': this.macPowerOff}}>
                    {this.state.currentMac !== mac.id && <Entity primitive="a-image"
                            id={`${mac.id}-a-image`}
                            data-id={mac.id}
                            alpha-map={`src: #${mac.id}-alpha`}
                            className="macTexture clickable"
                            events={{click: this.macClick}}
                            transparent material="alphaTest: 0.5"
                            src={`#${mac.id}-off`}
                            width={mac.width} height={mac.height} offset={mac.offset} repeat={mac.repeat}></Entity>}
                    {this.state.currentMac === mac.id && <Entity primitive="a-video"
                            id={`${mac.id}-a-video`}
                            data-id={mac.id}
                            alpha-map={`src: #${mac.id}-alpha`}
                            className="macTexture clickable"
                            events={{click: this.macClick}}
                            transparent material="alphaTest: 0.5"
                            src={`#${mac.id}-video`}
                            width={mac.width} height={mac.height} offset={mac.offset} repeat={mac.repeat}></Entity>}
                    <Entity className="macTitleTexture" position="0 -0.5 0.01"
                            data-id={mac.id}
                            primitive="a-image" src={`#${mac.id}-title`}
                            transparent material="alphaTest: 0.2" width="1" height="0.125"></Entity>
                    {this.state.currentMac === mac.id && !this.state.oculus &&
                    <Entity className="macTextTexture" position="0.75 0 0.02"
                            data-id={mac.id}
                            primitive="a-image" src={`#${mac.id}-desc`}
                            transparent material="alphaTest: 0.5"></Entity>}
                    <Entity className="macShadow" position="0 -1.48 0" primitive="a-image" src="#shadow"
                            rotation="-90 0 0" transparent opacity="0.5"></Entity>
                </Entity>);
            });
            families.push(<Entity key={`family-${idx}`}>{/*<Entity primitive="a-ring" color="#56b0e0" radius-inner={R - 0.1} radius-outer={R + 0.1} rotation="-90 0 0" position="0 0.005 0"></Entity>*/}{macs}</Entity>);
        });

        return (
            <div style={{height: '100%'}}>
                <div className="loading">Loading...</div>
                <Scene mac-scene events={{'enter-vr': this.enterVR, 'exit-vr': this.exitVR, 'loaded': this.onSceneLoaded}}>
                    <a-assets>
                        <img id="sky" src="assets/newsky1.png" alt=""></img>
                        <img id="floor" src="assets/newfloor1.png" alt=""></img>
                        <img id="logos" src="assets/logos.png" alt=""></img>
                        {this.macTextures}
                        {this.macDescs}
                        {this.macNames}
                        {this.macSounds}
                        <img id="shadow" src="assets/shadow.png" alt=""></img>
                        {this.music && <audio id="loop" src="assets/loop.mp3" loop ></audio>}
                    </a-assets>
                    <Entity primitive="a-light" type="point" color="FFF" position="0 100 0"></Entity>
                    <Entity primitive="a-sky" src="#sky"></Entity>
                    <Entity className="macSystem">
                        <Entity primitive="a-plane" static-body src="#floor" rotation="-90 180 0" scale="50 50 0" transparent></Entity>
                        <Entity primitive="a-plane" static-body src="#logos" rotation="-90 180 0" scale="7.5 7.5 0" transparent position="0 0.01 0"></Entity>
                        {families}
                    </Entity>
                    <Entity id="player" insideradius={`radius: ${SCENE_RADIUS}; origin: 0 ${USER_HEIGHT} 0`} joystick my-wasd-controls="head: #camera">
                        <Entity id="camera" camera position={`0 ${USER_HEIGHT} 0`} look-controls="pointerLockEnabled: true">
                            {!this.state.oculus && <Entity cursor={{fuse: this.state.cardboard}}
                                    events={{'raycaster-intersection': this.cursorMouseenter, 'raycaster-intersection-cleared': this.cursorMouseleave}}
                                    position="0 0 -1"
                                    geometry="primitive: ring; radiusInner: 0.02; radiusOuter: 0.03"
                                    material="color: orange; shader: flat"
                                    raycaster="objects: .clickable">
                                <a-animation begin="click" easing="ease-in" attribute="scale" dur="150"
                                             fill="forwards" from="0.1 0.1 0.1" to="1 1 1"></a-animation>
                                <a-animation begin="focusin" easing="ease-in" attribute="scale" dur="500"
                                             fill="forwards" from="1 1 1" to="1.5 1.5 1.5"></a-animation>
                                <a-animation begin="focusout" easing="ease-in" attribute="scale" dur="500"
                                             fill="forwards" from="1.5 1.5 1.5" to="1 1 1"></a-animation>
                            </Entity>}
                        </Entity>
                        <Entity id="leftHand" hand-controls="left" mycontrols>
                            <Entity raycaster="objects: .clickable; far: 0.3" position="0.042 0.015 0.2"></Entity>
                            {this.state.currentHand === 'rightHand' && <Entity position="0 -0.06 0" rotation="90 0 -90">{currentMacDesc}</Entity>}
                        </Entity>
                        <Entity id="rightHand" hand-controls="right" mycontrols>
                            <Entity raycaster="objects: .clickable; far: 0.3" position="-0.042 0.015 0.2"></Entity>
                            {this.state.currentHand === 'leftHand' && <Entity position="0 -0.06 0" rotation="90 0 90">{currentMacDesc}</Entity>}
                        </Entity>
                    </Entity>
                </Scene>
                {this.state.form && <LoginForm
                    data={this.userData}
                    onClose={this.handleLoginFormClose}
                    onSubmit={this.handleLoginFormSubmit}
                ></LoginForm>}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js